import { gql } from "@apollo/client";

export const GET_ALL_NETWORKS = gql`
  query allNetwork {
    allNetwork {
      edges {
        node {
          id
          pk
          title
          logo
          logoUrl
        }
      }
    }
  }
`;

export const GET_ALL_CERTIFICATIONS = gql`
  query allThirdPartyCertificate {
    allThirdPartyCertificate {
      edges {
        node {
          id
          pk
          title
          logoUrl
        }
      }
    }
  }
`;

export const UPDATE_CSO_NETWORK = gql`
  mutation updateCsoNetwork($networkIds: [ID]!) {
    updateCsoNetwork(input: { ids: $networkIds }) {
      csoNetwork {
        id
      }
    }
  }
`;

export const UPDATE_CSO_CERTIFICATION = gql`
  mutation updateCsoThirdPartyCertificate($ids: [ID]!) {
    updateCsoThirdPartyCertificate(input: { ids: $ids }) {
      csoThirdPartyCertificate {
        id
      }
    }
  }
`;
